const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/builds/$id/items.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { httpClient } from "@/lib/http-client";
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
interface PaginatedResponse<T> {
  data: T[];
  total: number;
}
export const Route = createFileRoute("/{-$locale}/builds/$id/items")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    params,
    context
  }) => {
    const {
      id
    } = params;
    const {
      queryClient
    } = context;
    await queryClient.prefetchQuery({
      queryKey: ["build-items", {
        id
      }],
      queryFn: () => httpClient.get<SingleItem[]>(`/builds/${id}/items`).catch(() => [])
    });
    return {
      id,
      dehydratedState: dehydrate(queryClient)
    };
  }
});